import { useMemo } from 'react';
import {
  useAssetsSearchListLazyQuery,
  useFormCategoriesSearchListLazyQuery,
  useSectorsSearchListLazyQuery,
  useSiteAreasSearchListLazyQuery,
  useSitesSearchListLazyQuery,
} from 'graphql-common';
import { TasksTableMultiselectFilterLoadOptions } from '@lib/components/TaskCompletions/TasksTableMultiselect/types';
import buildFilterLoadOptions from '@lib/components/TaskCompletions/TasksTableMultiselect/utils/buildFilterLoadOptions';
import { getSectorsLoadOptions } from 'utils/fetch/searchLists/sectorsSearchList';
import { getSitesLoadOptions } from 'utils/fetch/searchLists/sitesSearchList';
import { getSiteAreasLoadOptions } from 'utils/fetch/searchLists/siteAreasSearchList';
import { getAssetsLoadOptions } from 'utils/fetch/searchLists/assetsSearchList';
import { getFormCategoriesLoadOptions } from 'utils/fetch/searchLists/formCategoriesSearchList';

export default function useTasksTableMultiselectFilterLoadOptions(): TasksTableMultiselectFilterLoadOptions {
  const [fetchSectors] = useSectorsSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [fetchSites] = useSitesSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [fetchSiteAreas] = useSiteAreasSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [fetchAssets] = useAssetsSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [fetchFormCategories] = useFormCategoriesSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });

  return useMemo(
    () =>
      buildFilterLoadOptions({
        loadSectors: (filters) => getSectorsLoadOptions(fetchSectors, filters),
        loadSites: (filters) =>
          getSitesLoadOptions(fetchSites, filters, { includeSector: true }),
        loadSiteAreas: (filters) =>
          getSiteAreasLoadOptions(fetchSiteAreas, undefined, filters),
        loadEquipment: () => getAssetsLoadOptions(fetchAssets),
        loadFormCategories: (filters) =>
          getFormCategoriesLoadOptions(fetchFormCategories, filters),
      }),
    [
      fetchSectors,
      fetchSites,
      fetchSiteAreas,
      fetchAssets,
      fetchFormCategories,
    ],
  );
}
